module.exports = __webpack_public_path__ + "img/methoden_1280.6fc77fab.webp";